export function PostCardSkeleton() {
  return (
    <div className="overflow-hidden rounded-xl border border-border-primary bg-gradient-to-br from-bg-secondary to-bg-secondary/95">
      <div className="flex">
        {/* Thumbnail skeleton - matches new layout */}
        <div className="relative w-48 flex-shrink-0">
          <div className="h-full w-full bg-bg-tertiary animate-shimmer" style={{ minHeight: '140px' }} />
          {/* Content type badge skeleton */}
          <div className="absolute top-2 left-2 h-6 w-18 rounded-lg bg-bg-secondary/60 animate-shimmer" />
        </div>

        {/* Content skeleton */}
        <div className="flex min-w-0 flex-1 flex-col p-4">
          {/* Source & Time */}
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 rounded-sm bg-bg-tertiary animate-shimmer" />
            <div className="h-3 w-24 rounded bg-bg-tertiary animate-shimmer" />
            <div className="h-1 w-1 rounded-full bg-bg-tertiary" />
            <div className="h-3 w-16 rounded bg-bg-tertiary animate-shimmer" />
          </div>

          {/* Title */}
          <div className="mt-2.5 space-y-2">
            <div className="h-5 w-full rounded bg-bg-tertiary animate-shimmer" />
            <div className="h-5 w-4/5 rounded bg-bg-tertiary animate-shimmer" />
          </div>

          {/* Tags */}
          <div className="mt-2 flex gap-1.5">
            <div className="h-5 w-16 rounded-md bg-bg-tertiary/80 ring-1 ring-border-primary/30 animate-shimmer" />
            <div className="h-5 w-14 rounded-md bg-bg-tertiary/80 ring-1 ring-border-primary/30 animate-shimmer" />
            <div className="h-5 w-12 rounded-md bg-bg-tertiary/60 animate-shimmer" />
          </div>

          {/* Actions */}
          <div className="mt-auto flex items-center gap-1 pt-3">
            <div className="h-8 w-16 rounded-lg bg-bg-tertiary animate-shimmer" />
            <div className="h-8 w-14 rounded-lg bg-bg-tertiary animate-shimmer" />
            <div className="flex-1" />
            <div className="h-8 w-8 rounded-lg bg-bg-tertiary animate-shimmer" />
            <div className="h-8 w-8 rounded-lg bg-bg-tertiary animate-shimmer" />
            <div className="h-8 w-8 rounded-lg bg-bg-tertiary animate-shimmer" />
          </div>
        </div>
      </div>
    </div>
  );
}

export function PostCardGridSkeleton() {
  return (
    <div className="overflow-hidden rounded-2xl border border-border-primary/80 bg-gradient-to-b from-bg-secondary via-bg-secondary to-bg-tertiary/30">
      {/* Source Header skeleton */}
      <div className="flex items-center gap-2 px-4 pt-4 pb-2">
        <div className="h-6 w-6 rounded-lg bg-bg-tertiary animate-shimmer" />
        <div className="h-4 w-24 rounded bg-bg-tertiary animate-shimmer" />
        <div className="h-1 w-1 rounded-full bg-bg-tertiary" />
        <div className="h-3 w-12 rounded bg-bg-tertiary animate-shimmer" />
      </div>

      {/* Title skeleton */}
      <div className="px-4 pb-2.5 space-y-2">
        <div className="h-5 w-full rounded bg-bg-tertiary animate-shimmer" />
        <div className="h-5 w-3/4 rounded bg-bg-tertiary animate-shimmer" />
      </div>

      {/* Tags skeleton */}
      <div className="flex items-center gap-1.5 px-4 pb-3">
        <div className="h-6 w-14 rounded-lg bg-bg-tertiary/80 ring-1 ring-border-primary/30 animate-shimmer" />
        <div className="h-5 w-12 rounded-md bg-bg-tertiary/60 animate-shimmer" />
        <div className="h-5 w-10 rounded-md bg-bg-tertiary/60 animate-shimmer" />
      </div>

      {/* Thumbnail skeleton */}
      <div className="relative mx-4 mb-3 aspect-[16/10] overflow-hidden rounded-xl bg-bg-tertiary ring-1 ring-white/5 animate-shimmer" />

      {/* Actions footer skeleton */}
      <div className="flex items-center gap-1 border-t border-border-primary/50 px-3 py-2.5 bg-gradient-to-t from-bg-tertiary/20 to-transparent">
        <div className="h-7 w-7 rounded-lg bg-bg-tertiary animate-shimmer" />
        <div className="h-4 w-8 rounded bg-bg-tertiary animate-shimmer" />
        <div className="h-7 w-7 rounded-lg bg-bg-tertiary animate-shimmer" />
        <div className="mx-1 h-4 w-px bg-border-primary/50" />
        <div className="h-7 w-14 rounded-lg bg-bg-tertiary animate-shimmer" />
        <div className="flex-1" />
        <div className="h-8 w-8 rounded-lg bg-bg-tertiary animate-shimmer" />
        <div className="h-8 w-8 rounded-lg bg-bg-tertiary animate-shimmer" />
      </div>
    </div>
  );
}
